<template>
	<div id="app">
		<Nav-list class="navPublic"></Nav-list>
		<router-view class="contPublic"></router-view>
	</div>
</template>
<script>
	import NavList from './components/NavList.vue';
	export default {
		data() {
			return {};
		},
		components: {
			NavList,
		},
		mounted() {
			//  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			//       // alert('移动端');
			//       window.location.href = "http://sora.wsandos.com/demo/move/#/";
			//   }
			//   else{
			//       window.location.href = "http://sora.wsandos.com/demo/PC/#/";
			//   }
		},
	};
</script>

<style lang="less">
	.day-mode {
		background: #dbdcdc !important;
		color: #000 !important;
	}
	.night-mode {
		background: #1a1a1a !important;
		color: #fff !important;
	}
	@font-face {
		font-family: nexabold;
		src: url(../public/font/NexaBold.otf);
	}
	#app {
		width: 100%;
		height: 100vh;
		overflow: hidden;
		display: flex;
	}

	.clearF::after {
		display: block;
		clear: both;
		content: '';
	}
	.navPublic {
		// position: absolute;
		display: inline-block;
		min-width: 140px;
		min-height: 930px;
		width: 20%;
		height: 100vh;
		overflow: auto;
		padding: 44px 40px 40px 40px;
		vertical-align: top;
	}
	.nav::-webkit-scrollbar {
		width: 0px;
	}

	.contPublic {
		// position: absolute;
		// left: 20%;
		min-width: 140px;
		display: inline-block;
		width: 80%;
		height: 100%;
	}
	// @media screen and (min-width: 284px) and (max-width: 870px) {
	// 	.navPublic {
	// 		padding: 0;
	// 		width: 40%;
	// 	}
	// 	.contPublic {
	// 		width: 60%;
	// 	}
	// }
	@media screen and (max-width: 384px) {
		.navPublic {
			width: 100%;
			display: block;
			padding: 0;
		}
		.contPublic {
			width: 100%;
			display: block;
		}
	}

	.sora-h1 {
		font-size: 40px;
		color: #231815;
		font-family: nexabold;
	}
</style>
